module.exports = __webpack_public_path__ + "static/media/instagram-relax-tabletPro.13b3344a.png";